angular.module('app').factory('mediaService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/media/");

        return {
            addImage: function (requestData) {
                return restAngular.one("create").post("", requestData)
            },
            getImages: function (requestObject) {
                return restAngular.one("get").customGET(param(requestObject))
            },
            deleteImage: function (requestData) {
                return restAngular.one("delete").customGET(param(requestData))
            }
        }
    }
]);